import { render, staticRenderFns } from "./LoldocupLeague.vue?vue&type=template&id=351f7662&"
import script from "./LoldocupLeague.vue?vue&type=script&lang=js&"
export * from "./LoldocupLeague.vue?vue&type=script&lang=js&"
import style0 from "./LoldocupLeague.vue?vue&type=style&index=0&id=351f7662&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports